import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthStore } from '../auth/auth.store';
import { ToastService } from '../services/toast.service';

/**
 * Phase 53 — onboarding incomplete guard (D-05, D-06, D-08, D-09)
 *
 * Blocks shell children when authenticated user has no business.
 * Public /onboarding route is NOT guarded — it handles resume internally.
 * Uses hybrid confirmNeedsOnboarding (JWT fast + GET /auth/me definitive).
 * Returns UrlTree (not navigate+false) for correct router lifecycle.
 * Toast guide before redirect, query param for future context.
 */
async function checkOnboardingIncomplete(router: Router, authStore: AuthStore, toast: ToastService): Promise<boolean | UrlTree> {
  if (!authStore.isAuthenticated()) return true;
  const needs = await authStore.confirmNeedsOnboarding();
  if (needs) {
    toast.show('Antes de continuar es necesario completar el onboarding', 'info', 4000);
    return router.createUrlTree(['/onboarding'], { queryParams: { reason: 'onboarding_incomplete' } });
  }
  return true;
}

export const onboardingIncompleteGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const toast = inject(ToastService);
  return checkOnboardingIncomplete(router, authStore, toast);
};

export const onboardingIncompleteGuardChild: CanActivateChildFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const toast = inject(ToastService);
  return checkOnboardingIncomplete(router, authStore, toast);
};
